import React from 'react'
import i18next from 'i18next'
import { Trans } from 'react-i18next'

export default class DisableMultiTab extends React.Component {
  render() {

    let isFrench = i18next.language.indexOf("fr")
    let srcLogo
    if (isFrench === -1) {
      srcLogo = "/static/img/TD-Insurance.svg"     
    } else {
      srcLogo = "/static/img/TD-Assurance.svg"     
    }

    return (
      <div className='d-flex flex-column min-vh-100'>
        <div key="headerHolder" className="td-parent">
          <div className="headertopline">
          </div>
          {window.Tenant === 'td' ? <header className="td_rq_menu td-navigation td-left-menu" role="banner">
            <div className="container my-0" id="navContainer">
              <div className="row">
                <div className="td-off-canvas-header col col-lg-3 pe-0 no-print">
                  <div className="td-logo-title-container no-print ">
                    <a id="tdLogo" className="td-logo focusBorderStye d-inline-flex" href="/travel/trip-info/">
                      <img alt="TD Canada Trust home" id="logoDesktop" className="logo " height={43} src='/static/img/framework/TDShield.svg' />
                      <img alt="TD Canada Trust home" id="logoMobile" className="logo " height={43} src='/static/img/framework/TDShield.svg' />
                    </a>
                    <div className='td-insurance-logo'>
                      <img alt="TD Insurance" id="tdInsurance" className="tdInsurance-logo mt-15 ms-20" height={15} src={i18next.t("trip_infopage.td_insurance_logo")} />
                    </div>
                  </div>
                </div>                
              </div>
            </div>
          </header> : <header className="td_rq_menu td-navigation td-left-menu h-auto" role="banner">
            <div className="td-container" id="navContainer">
              <div className="row nomargin justify-content-between">
                <div className="td-off-canvas-header col-9 col-sm-2">
                  <div className="td-logo-title-container  no-print ">
                    <a id='tdLogo' className="td-logo focusBorderStye displayblock" href="/travel/trip-info/">
                      <img alt="TD Canada Trust home" id="logoDesktop" className="logo " src={srcLogo} />
                      <img alt="TD Canada Trust home" id="logoMobile" className="logo " src={srcLogo} />
                    </a>
                  </div>
                </div>                
              </div>
            </div>
          </header>}
        </div>

        <main className='heading_sec text-center w-100 py-4 py-sm-5 px-2 mt-0 mt-sm-2'>
          <h1 className='h2 lh-base mb-4'><Trans i18nKey="disableMultiTab.heading1">Multiple tabs are not supported for this application to ensure data integrity.</Trans></h1>
          <h2 className='h2 lh-base mb-3'><Trans i18nKey="disableMultiTab.heading2">Please return to the original tab or close this window.</Trans></h2>
        </main>

      </div>
    )
  }
}